import React from "react";
import Modal from "../../../elements/Modal";
import Button from "../../../form/Button";

const SubscriptionModal = ({
  open = false,
  onClose = () => {},
  deleteHandler = () => {},
  loading = false,
  customMessage,
  deleteButtonIcon,
  titleIcon,
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={() => onClose()}
      title={"Cancel Recurring Payment"}
      size="sm"
      modaltitleClasses={"!text-slate-200 text-[15px]"}
      childrenClasses={"!rounded-b-lg"}
      titleIcon={titleIcon}
    >
      <div className="text-center mb-3 text-slate-500">
        {customMessage
          ? customMessage
          : "Confirm cancellation of recurring payment?"}
      </div>
      <div className="flex gap-2 justify-center">
        <Button
          buttonIconPosition={"left"}
          buttonIcon={"fa-regular fa-close !text-sm"}
          buttonLabel={"No"}
          buttonFunction={() => onClose()}
          buttonClasses="!py-2 !px-2 border border-chestnut-rose !text-chestnut-rose rounded-lg !bg-transparent !h-auto"
          buttonLabelClasses={"!text-sm"}
        />
        <Button
          buttonFunction={deleteHandler}
          buttonIconPosition={"left"}
          isDisable={loading}
          isLoaderDisabled={true}
          buttonIcon={
            loading
              ? "fa-duotone fa-spinner-third animate-spin"
              : deleteButtonIcon || "fa-regular fa-trash-can !text-sm"
          }
          buttonLabel={"Yes"}
          buttonClasses={
            "!py-2 !px-2 rounded-lg text-white !h-auto !bg-red-600 hover:!bg-red-700 transition-all duration-300 !border-0"
          }
          buttonLabelClasses={"!text-sm"}
        />
      </div>
    </Modal>
  );
};

export default SubscriptionModal;
